var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 6.18668C13.0667 6.18668 12.8533 6.40001 12.8533 6.66668C12.8533 6.92268 13.0667 7.14668 13.3333 7.14668H14.6027V11.5093H9.376V7.13601H10.656C10.912 7.13601 11.136 6.91201 11.136 6.65601C11.136 6.38934 10.912 6.17601 10.656 6.17601H6.92267C6.656 6.17601 6.44267 6.38934 6.44267 6.65601C6.44267 6.91201 6.656 7.13601 6.92267 7.13601H8.192V16.8427H6.912C6.64534 16.8427 6.432 17.056 6.432 17.3227C6.432 17.5787 6.64534 17.8027 6.912 17.8027H10.6453C10.9013 17.8027 11.1253 17.5787 11.1253 17.3227C11.1253 17.056 10.9013 16.8427 10.6453 16.8427H9.35467V12.4587H14.5813V16.832H13.3013C13.0347 16.832 12.8213 17.0453 12.8213 17.312C12.8213 17.568 13.0347 17.792 13.3013 17.792H17.0347C17.2907 17.792 17.5147 17.568 17.5147 17.312C17.5147 17.0453 17.2907 16.832 17.0347 16.832H15.744V7.12534H17.024C17.28 7.12534 17.504 6.90134 17.504 6.64534C17.504 6.37868 17.28 6.16534 17.024 6.16534H13.28L13.3333 6.18668Z",
    fill: "#929AA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadingIcon);
export default __webpack_public_path__ + "static/media/heading-icon.0eff4e760bb4737110196e3965bd4cb9.svg";
export { ForwardRef as ReactComponent };